import React, { useState } from "react";
import SwitchTab from "../Components/UI/SwtichTabs";
import guideLion from "../../../assets/image/lion-watercolor.png";
import MyForm from "../Components/UI/MyForm";
import { postUserDetails } from "../../../api/leads";
import { errorMessage, successMessage } from "../Util/Toaster";

export default function Guide({ mode = "1" }) {
  const [formData, setFormData] = useState(null);

  const downloadField = [
    { type: "text", placeholder: "Name", name: "name" },
    { type: "phone", placeholder: "Phone", name: "phone" },
    { type: "email", placeholder: "Email Address", name: "email" },
    // { type: "text", placeholder: "Street Address", name: "Address" },
  ];
  const printFields = [
    { type: "text", placeholder: "Name", name: "name" },
    { type: "phone", placeholder: "Phone", name: "phone" },
    { type: "email", placeholder: "Email Address", name: "email" },
    { type: "text", placeholder: "Street Address", name: "Address" },
    { type: "text", placeholder: "City", name: "city" },
    { type: "text", placeholder: "State", name: "state" },
    { type: "text", placeholder: "ZIP", name: "zipCode" },
  ];

  const tabsConfig = {
    1: [
      {
        title: (
          <>
            <i className="fa-regular fa-circle-down me-2"></i>Download Now
          </>
        ),
        formType: "1",
        classname: "col-md-7 col-lg-7 col-xl-7",
      },
      {
        title: (
          <>
            <i className="fa-regular fa-envelope me-2"></i>Request A Printed
            Copy
          </>
        ),
        formType: "2",
        classname: "col-md-6 col-lg-6 ",
      },
    ],
    2: [
      {
        title: (
          <>
            <i className="fa-regular fa-circle-down me-2"></i>Download Now
          </>
        ),
        formType: "3",
        classname: "col-md-7 col-lg-7 col-xl-7",
      },
      {
        title: (
          <>
            <i className="fa-regular fa-envelope me-2"></i>Request A Printed
            Copy
          </>
        ),
        formType: "4",
        classname: "col-md-6 col-lg-6 ",
      },
    ],
  };

  const formFieldsMap = {
    1: downloadField,
    2: printFields,
    3: downloadField,
    4: printFields,
  };

  // Submit handler passed to MyForm
  const onFormSubmit = async (userDetails, formtype) => {
    const dataForSubmission = {
      ...userDetails,
      type: formtype,
    };
    console.log("dataForSubmission", dataForSubmission);

    try {
      const data = await postUserDetails(dataForSubmission);
      console.log("data", data.data);
      if (data.data > 0) {
        successMessage("Form Submit successfully");
      } else {
        errorMessage("An error occurred during submission.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      errorMessage("An error occurred during submission.");
    }
  };
  const tabsToShow = tabsConfig[mode] || [];

  const tabs = tabsToShow.map(({ title, formType, classname }) => ({
    title,
    content: (
      <div className="tab-pane-inner">
        <p className="tab-heading">
          Get your guide delivered for easy access anytime, anywhere.
          <i> – ready to read anytime.</i>
        </p>
        <MyForm
          fields={formFieldsMap[formType]}
          submitTxt="Submit"
          classname={classname}
          onFormSubmit={(userDetails) => onFormSubmit(userDetails, formType)}
          inputClass="w-100 guide-input"
        />
        <p className="talk-soon mt-4">
          Let's talk soon to go over any questions or next steps !
        </p>
      </div>
    ),
  }));

  return (
    <>
      <div className="container-fluid guide-buyer-section">
        <div className="container buyer-form-section">
          <div className="lion-img">
            <img src={guideLion} alt="" />
          </div>
          <h1 className="main-heading-buyer">
            Choose How You'd Like to Receive Your Guide
          </h1>
          <SwitchTab tabs={tabs} navItemClass="me-4" />
        </div>
      </div>
    </>
  );
}
